import { terminatePidApi } from '../../utils/apisConsts'
import DeleteSchedule from './deleteSchedule'

export default function TerminateAnalytics() {
  return <DeleteSchedule placeholder='Enter The PID' validationMessage='PID is mandatory' API={terminatePidApi}/>
}
